import { CENTERLINE } from "../../actions/portal/";

export default function(state = [0, 0], action) {
  switch (action.type) {
    case CENTERLINE:
      return action.payload;
    default:
  }
  return state;
}
